/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_No_Events_ToastInputs */

const en_error_nav_no_events_toast = /** @type {(inputs: Error_Nav_No_Events_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No events in the current group.`)
};

const fr_error_nav_no_events_toast = /** @type {(inputs: Error_Nav_No_Events_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun evenement dans le groupe actuel.`)
};

const de_error_nav_no_events_toast = /** @type {(inputs: Error_Nav_No_Events_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In der aktuellen Gruppe sind keine Ereignisse verzeichnet.`)
};

const it_error_nav_no_events_toast = /** @type {(inputs: Error_Nav_No_Events_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun evento nel gruppo corrente.`)
};

const ru_error_nav_no_events_toast = /** @type {(inputs: Error_Nav_No_Events_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В текущей группе нет событий.`)
};

const es_error_nav_no_events_toast = /** @type {(inputs: Error_Nav_No_Events_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay eventos en el grupo actual.`)
};

const zh_cn2_error_nav_no_events_toast = /** @type {(inputs: Error_Nav_No_Events_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前组内没有事件。`)
};

const ja_error_nav_no_events_toast = /** @type {(inputs: Error_Nav_No_Events_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在のグループにはイベントがありません。`)
};

const hi_error_nav_no_events_toast = /** @type {(inputs: Error_Nav_No_Events_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान समूह में कोई इवेंट नहीं है।`)
};

const pt_pt2_error_nav_no_events_toast = /** @type {(inputs: Error_Nav_No_Events_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não há eventos no grupo atual.`)
};

/**
* | output |
* | --- |
* | "No events in the current group." |
*
* @param {Error_Nav_No_Events_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_no_events_toast = /** @type {((inputs?: Error_Nav_No_Events_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_No_Events_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_no_events_toast(inputs)
	if (locale === "de") return de_error_nav_no_events_toast(inputs)
	if (locale === "it") return it_error_nav_no_events_toast(inputs)
	if (locale === "ru") return ru_error_nav_no_events_toast(inputs)
	if (locale === "es") return es_error_nav_no_events_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_no_events_toast(inputs)
	if (locale === "ja") return ja_error_nav_no_events_toast(inputs)
	if (locale === "hi") return hi_error_nav_no_events_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_no_events_toast(inputs)
	return en_error_nav_no_events_toast(inputs)
});